import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Box, fade} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import IntlMessages from "../../../utils/IntlMessages";
import Button from "@material-ui/core/Button";
import {AuhMethods} from "../../../../services/auth";
import ContentLoader from "../../ContentLoader";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CmtImage from "../../../../@coremat/CmtImage";
import Typography from "@material-ui/core/Typography";
import {CurrentAuthMethod} from "../../../constants/AppConstants";
import AuthWrapper from "./AuthWrapper";
import {NavLink} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    authThumb: {
        backgroundColor: fade(theme.palette.primary.main, 0.12),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        [theme.breakpoints.up("md")]: {
            width: "50%",
            order: 2
        }
    },
    authContent: {
        padding: 30,
        [theme.breakpoints.up("md")]: {
            width: props => (props.variant === "default" ? "50%" : "100%"),
            order: 1
        },
        [theme.breakpoints.up("xl")]: {
            padding: 50
        }
    },
    titleRoot: {
        marginBottom: 14,
        color: theme.palette.text.primary
    },
    textFieldRoot: {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: fade(theme.palette.common.dark, 0.12)
        }
    },
    textCapital: {
        textTransform: "capitalize"
    },
    textAcc: {
        textAlign: "center",
        "& a": {
            marginLeft: 4
        }
    },
    alrTextRoot: {
        textAlign: "center",
        [theme.breakpoints.up("sm")]: {
            textAlign: "right"
        }
    }
}));

//variant = 'default', 'standard', 'bgColor'
const SignUp = ({
                    method = CurrentAuthMethod,
                    variant = "default",
                    wrapperVariant = "default"
                }) => {
    const [name, setName] = useState("Demo User");
    const [email, setEmail] = useState("demo@example.com");
    const [password, setPassword] = useState("demo#123");
    const dispatch = useDispatch();
    const classes = useStyles({variant});

    const onSubmit = () => {
        dispatch(AuhMethods[method].onRegister({name, email, password}));
    };

    const JSON5 = require("json5");
    const {authUser} = useSelector(({auth}) => auth);

    let settings = null;
    let logoPath = "inovacio";

    if (authUser) {
        settings = authUser["settings"];
        if (settings !== "" && settings !== null) {
            settings = JSON5.parse(settings);
            logoPath = settings["logo"];
        }
    } else {
        let settings = window.localStorage.getItem('settings');
        if (settings !== '' && settings !== 'null' && settings !== null) {
            settings = JSON5.parse(settings);
            logoPath = settings["logo"];
        }
    }

    return (
        <AuthWrapper variant={wrapperVariant}>
            {variant === "default" ? (
                <Box className={classes.authThumb}>
                    <CmtImage src={"/images/auth/sign-up-img.png"}/>
                </Box>
            ) : null}
            <Box className={classes.authContent}>
                <Box mb={7}>
                    <CmtImage src={`/branding/${logoPath}/logo.png`}/>
                </Box>
                <Typography component="div" variant="h1" className={classes.titleRoot}>
                    Create an account
                </Typography>
                <form>
                    <Box mb={2}>
                        <TextField
                            label={<IntlMessages id="appModule.name"/>}
                            fullWidth
                            onChange={event => setName(event.target.value)}
                            defaultValue={name}
                            margin="normal"
                            variant="outlined"
                            className={classes.textFieldRoot}
                        />
                    </Box>
                    <Box mb={2}>
                        <TextField
                            label={<IntlMessages id="appModule.email"/>}
                            fullWidth
                            onChange={event => setEmail(event.target.value)}
                            defaultValue={email}
                            margin="normal"
                            variant="outlined"
                            className={classes.textFieldRoot}
                        />
                    </Box>
                    <Box mb={2}>
                        <TextField
                            type="password"
                            label={<IntlMessages id="appModule.password"/>}
                            fullWidth
                            onChange={event => setPassword(event.target.value)}
                            defaultValue={password}
                            margin="normal"
                            variant="outlined"
                            className={classes.textFieldRoot}
                        />
                    </Box>

                    <Box
                        display="flex"
                        flexDirection={{xs: "column", sm: "row"}}
                        alignItems={{sm: "center"}}
                        justifyContent={{sm: "space-between"}}
                        mb={3}
                    >
                        <Box mb={{xs: 2, sm: 0}}>
                            <Button onClick={onSubmit} variant="contained" color="primary">
                                <IntlMessages id="appModule.regsiter"/>
                            </Button>
                        </Box>

                        <Typography className={classes.alrTextRoot}>
                            <NavLink to="/signin">
                                <IntlMessages id="signUp.alreadyMember"/>
                            </NavLink>
                        </Typography>
                    </Box>
                </form>

                <Box mb={3}>{dispatch(AuhMethods[method].getSocialMediaIcons())}</Box>

                <Typography className={classes.textAcc}>
                    Have an account?
                    <NavLink to="/signin">Sign In</NavLink>
                </Typography>
                <ContentLoader/>
            </Box>
        </AuthWrapper>
    );
};

export default SignUp;
